export default {
    props: {
        headerHeight: {
            type: Number,
            default: 0
        }
    },
    computed: {
        offsetTop() {
            return this.headerHeight + this.selfHeight - 1 + 'px'
        },
        typeOffsetTop() {
            return this.headerHeight + this.selfHeight - 10 + this.totalHeight + 'px'
        }
    },
    data() {
        return {
            selfHeight: 0,
            totalHeight: 0
        }
    },
    mounted() {
        this.selfHeight = document.querySelector('.van-tabs__wrap').clientHeight
        this.totalHeight = this.$refs.total && this.$refs.total.clientHeight || 0
    }
}